import React from 'react';
import Navbar from './global-components/navbar';
import JEEDetails from './section-components/repeater-batch';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";
import Page_header from './global-components/page-headerrepeater';

const RepeaterBatch = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>Best Repeater's Batch In Chennai | Repeater's Batch in Chennai</title>
            <meta name="description" content="The candidates that study with MIET get the best JEE coaching in Chennai to students and a kick-start in their preparation for the entrance exams" />
        </Helmet>
        {/* <PageHeader headertitle="JEE"  /> */}
        <Page_header headertitle="REPEATER'S BATCH"/>
        <JEEDetails />
        <Footer />
    </div>
}

export default RepeaterBatch